import { isUndefined } from 'lodash';
import axiosInstance from 'src/utils/axios';
import parse from 'src/utils/parse';

export interface CreateFrsCategoryPayload {
  projectId: string;
  name: string;
  parentCategoryId?: string;
}

export interface GetFrsCategoriesQuery {
  projectId: string;
  onlActive: boolean;
}

class FrsCategoriesApi {
  async getFrsCategoriesHierarchy(query: GetFrsCategoriesQuery): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_CASES}/frs-categories/hierarchy`, {
          params: query,
        })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async createFrsCategory(payload: CreateFrsCategoryPayload): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post(`${process.env.REACT_APP_CASES}/frs-categories`, payload)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export const frsCategoriesApi = new FrsCategoriesApi();
